import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10.5 8v8","key":"svg-0"}],["path",{"d":"M14.5 8l-3 4l3 4","key":"svg-1"}],["path",{"d":"M10.5 12h1","key":"svg-2"}]]

/**
 * IconLetterKSmall
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLWstc21hbGwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEwLjUgOHY4IiAvPgogIDxwYXRoIGQ9Ik0xNC41IDhsLTMgNGwzIDQiIC8+CiAgPHBhdGggZD0iTTEwLjUgMTJoMSIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/letter-k-small
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterKSmall = createReactComponent('outline', 'letter-k-small', 'LetterKSmall', __iconNode);

export default IconLetterKSmall;